module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_6000.c3e11b38.png";